import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import { API_URL } from "../../../environment";

interface AccountModalProps {
  show: boolean;
  onHide: () => void;
  email: string | null;
  isAdmin: boolean;
}

// "Minha conta": dados do login e troca da propria senha. Qualquer perfil pode trocar;
// o backend so aceita com a senha atual correta.
const AccountModal: React.FC<AccountModalProps> = ({ show, onHide, email, isAdmin }) => {
  const [senhaAtual, setSenhaAtual] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [mostrar, setMostrar] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);
  const [sucesso, setSucesso] = useState(false);

  useEffect(() => {
    if (show) {
      setSenhaAtual("");
      setNovaSenha("");
      setConfirmar("");
      setMostrar(false);
      setErro(null);
      setSucesso(false);
    }
  }, [show]);

  const salvar = async (e: React.FormEvent) => {
    e.preventDefault();
    setErro(null);
    if (!senhaAtual || !novaSenha || !confirmar) {
      setErro("Preencha os três campos.");
      return;
    }
    if (novaSenha.length < 6) {
      setErro("A nova senha precisa ter pelo menos 6 caracteres.");
      return;
    }
    if (novaSenha !== confirmar) {
      setErro("A confirmação não confere com a nova senha.");
      return;
    }
    setSalvando(true);
    try {
      const resp = await fetch(`${API_URL}/minha_conta/senha`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ login: email, senha_atual: senhaAtual, nova_senha: novaSenha }),
      });
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok) {
        setErro(data.error || "Não foi possível alterar a senha.");
        return;
      }
      setSucesso(true);
      setSenhaAtual("");
      setNovaSenha("");
      setConfirmar("");
    } catch {
      setErro("Erro de conexão. Tente novamente.");
    } finally {
      setSalvando(false);
    }
  };

  const tipo = mostrar ? "text" : "password";

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Minha conta</Modal.Title>
      </Modal.Header>
      <Form onSubmit={salvar}>
        <Modal.Body>
          <div className="mb-3">
            <div className="text-muted small">Login</div>
            <div className="fw-semibold">{email}</div>
          </div>
          <div className="mb-4">
            <div className="text-muted small">Perfil</div>
            <div className="fw-semibold">{isAdmin ? "Administrador" : "Operador"}</div>
          </div>

          <h6 className="mb-3">Alterar senha</h6>
          {sucesso && <Alert variant="success">Senha alterada. Use a nova senha no próximo login.</Alert>}
          {erro && <Alert variant="danger">{erro}</Alert>}
          <Form.Group className="mb-2">
            <Form.Label>Senha atual</Form.Label>
            <Form.Control type={tipo} value={senhaAtual} autoComplete="current-password"
                          onChange={(e) => setSenhaAtual(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Nova senha</Form.Label>
            <Form.Control type={tipo} value={novaSenha} autoComplete="new-password"
                          onChange={(e) => setNovaSenha(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Confirmar nova senha</Form.Label>
            <Form.Control type={tipo} value={confirmar} autoComplete="new-password"
                          onChange={(e) => setConfirmar(e.target.value)} />
          </Form.Group>
          <Form.Check type="checkbox" id="mostrar-senhas" label="Mostrar senhas"
                      checked={mostrar} onChange={(e) => setMostrar(e.target.checked)} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>Fechar</Button>
          <Button variant="primary" type="submit" disabled={salvando}>
            {salvando ? "Salvando..." : "Salvar nova senha"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AccountModal;
